<template>
    <tr v-if="Object.hasOwn(session, 'customLine')">
        <td colspan="2">
            <h4 class="session__custom-line">
                {{ session.customLine[0].value }}
            </h4>
        </td>
    </tr>
    <tr v-else-if="Object.hasOwn(session, 'title')">
        <td :style="`color: ${color}`" class="session__hour">
            <!-- 00:00 | SESJA X: TYTUŁ SESJI -->
            <div
                v-if="Object.hasOwn(session, 'hour')"
                class="session__hour--div"
            >
                <span class="session-hour">
                    <template v-if="typeof session.hour === 'string'">
                        <span>{{ session.hour }}</span>
                    </template>
                    <template v-else>
                        <span>{{ session.hour.value }}</span>
                    </template>
                </span>
            </div>
            <!-- SESJA X | TYTUŁ SESJI -->
            <div v-else class="session__hour--div">
                <template v-if="Object.hasOwn(session, 'sessionNumber')">
                    <template v-if="typeof session.sessionNumber === 'string'">
                        <span>SESJA {{ session.sessionNumber }}</span>
                    </template>
                    <template v-else>
                        <span>SESJA {{ session.sessionNumber.value }}</span>
                    </template>
                </template>
            </div>
        </td>
        <td class="session__title">
            <div
                v-if="Object.hasOwn(session, 'title')"
                class="session__title--wrapper"
            >
                <!-- Tablica tytułów -->
                <template v-if="Array.isArray(session.title)">
                    <div
                        v-for="(title, index) in session.title"
                        :style="`color: ${color}`"
                        class="session__title--main-line"
                    >
                        <!-- Posidada godzinę -> Numer sesji w tytule -->
                        <template
                            v-if="
                                Object.hasOwn(session, 'hour') &&
                                Object.hasOwn(session, 'sessionNumber') &&
                                index === 0
                            "
                        >
                            <template
                                v-if="typeof session.sessionNumber === 'string'"
                            >
                                <template v-if="typeof title === 'string'">
                                    <span>{{
                                            `SESJA ${session.sessionNumber}: ${title}`
                                        }}</span>
                                </template>
                                <template v-else>
                                    <span>{{
                                            `SESJA ${session.sessionNumber}: ${title.value}`
                                        }}</span>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="typeof title === 'string'">
                                    <span>{{
                                            `SESJA ${session.sessionNumber.value}: ${title}`
                                        }}</span>
                                </template>
                                <template v-else>
                                    <span>{{
                                            `SESJA ${session.sessionNumber.value}: ${title.value}`
                                        }}</span>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <span
                            ><template v-if="typeof title === 'string'">
                                    {{ title }}
                                </template>
                                <template v-else>
                                    {{ title.value }}
                                </template></span
                            >
                        </template>
                    </div>
                </template>
                <!-- Tytuł to pojedynczy obiekt lub string -->
                <template v-else>
                    <div
                        :style="`color: ${color}`"
                        class="session__title--main-line"
                    >
                        <!-- Posidada godzinę -> Numer sesji w tytule -->
                        <template
                            v-if="
                                Object.hasOwn(session, 'hour') &&
                                Object.hasOwn(session, 'sessionNumber')
                            "
                        >
                            <template
                                v-if="typeof session.sessionNumber === 'string'"
                            >
                                <template
                                    v-if="typeof session.title === 'string'"
                                >
                                    <span>{{
                                            `SESJA ${session.sessionNumber}: ${session.title}`
                                        }}</span>
                                </template>
                                <template v-else>
                                    <span>{{
                                            `SESJA ${session.sessionNumber}: ${session.title.value}`
                                        }}</span>
                                </template>
                            </template>
                            <template v-else>
                                <template
                                    v-if="typeof session.title === 'string'"
                                >
                                    <span>{{
                                            `SESJA ${session.sessionNumber.value}: ${session.title}`
                                        }}</span>
                                </template>
                                <template v-else>
                                    <span>{{
                                            `SESJA ${session.sessionNumber.value}: ${session.title.value}`
                                        }}</span>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <span
                            ><template
                                v-if="typeof session.title === 'string'"
                            >
                                    {{ session.title }}
                                </template>
                                <template v-else>
                                    {{ session.title.value }}
                                </template></span
                            >
                        </template>
                    </div>
                </template>

                <!-- Moderatorzy -->
                <div v-if="Object.hasOwn(session, 'moderators')">
                    <template
                        v-if="!session.moderators.every(moderator => Object.hasOwn(moderator, 'sessionModeratorPrefix'))">
                        <span
                            v-if="Object.hasOwn(session, 'sessionModeratorPrefix')"
                            class="session__moderator-prefix"
                        >
                            {{ session.sessionModeratorPrefix.value }}
                        </span>
                        <span v-else class="session__moderator-prefix">
                            {{
                                `Moderatorzy: `
                            }}
                        </span>
                    </template>
                    <template
                        v-if="session.moderators.every(moderator => Object.hasOwn(moderator, 'sessionModeratorPrefix'))">
                        <span
                            v-for="(moderator, index) in session.moderators"
                            class="session__moderator-name"
                        >
                            <strong>{{ `${moderator.sessionModeratorPrefix.value} ` }}</strong>
                            <template v-if="Object.hasOwn(moderator, 'workplace')">

                            {{
                                    `${moderator.name}, ${
                                        moderator.workplace.value
                                    }`
                                }}
                        </template>
                        <template v-else>
                            {{
                                `${moderator.name}`
                            }}
                        </template>
                            <br>
                        </span>
                    </template>
                    <template v-else>
                    <span
                        v-for="(moderator, index) in session.moderators"
                        class="session__moderator-name"
                    >
                        <template v-if="Object.hasOwn(moderator, 'workplace')">
                            {{
                                `${moderator.name}, ${
                                    moderator.workplace.value
                                }${
                                    session.moderators.length > 1 &&
                                    index < session.moderators.length - 1
                                        ? "; "
                                        : ""
                                }`
                            }}
                        </template>
                        <template v-else>
                            {{
                                `${moderator.name}${
                                    session.moderators.length > 1 &&
                                    index < session.moderators.length - 1
                                        ? ", "
                                        : ""
                                }`
                            }}
                        </template>
                    </span>
                    </template>
                </div>

                <!-- Sesja sponsorowana -->
                <template v-if="Object.hasOwn(session, 'sponsors')">
                    <div
                        v-for="sponsor in session.sponsors"
                        class="session__sponsored-wrapper"
                    >
                        <p class="session__sponsored-prefix">
                            {{ sponsor.prefix }}
                        </p>
                        <img
                            :alt="sponsor.companyName"
                            :class="sponsor.size ? `session__sponsored-img--${sponsor.size}` : ''"
                            :src="sponsor.imageSrc"
                            class="session__sponsored-img"
                        />
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ProgramLecture from "./programLecture.vue";

export default {
    data() {
        return {
            color: "#003dd9",
        };
    },
    props: {
        session: {
            type: Object,
        },
        settings: {
            type: Object,
        },
    },
    components: {
        ProgramLecture,
    },
    created: function () {
        if (Object.hasOwn(this.settings, "color")) {
            this.color = this.settings.color;
        }
    },
};
</script>

<style lang="scss">
td.session__hour {
    display: flex;
    height: 100%;
    width: 100%;
}

.session {
    &__hour {
        display: flex;
        font-weight: 600;
        font-size: 1.125rem;
        height: 100%;
        width: 100%;

        &--div {
            padding-block: 30px 5px;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
        }
    }

    &__title {
        &--wrapper {
            padding-block: 30px 5px;
            display: flex;
            flex-direction: column;
        }

        &--main-line {
            font-weight: 600;
            font-size: 1.125rem;
        }
    }

    // &__moderator-name {
    //     font-style: italic;
    // }

    &__moderator-prefix {
        font-weight: 500;
    }

    &__custom-line {
        font-size: 1.25rem;
        margin-bottom: 0;
    }
}

div.session__sponsored-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
    column-gap: 1rem;
    font-size: 16px;
}

p.session__sponsored-prefix {
    margin-block: 0;
    // flex: 0 0 auto;
    vertical-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
}

img.session__sponsored-img {
    // display: block;
    max-height: 1.75em;
    // flex: 0 0 auto;
    font-size: 16px;
}

img.session__sponsored-img .session__sponsored-img--bigger {
    max-height: 2.5em;
}

img.session__sponsored-img .session__sponsored-img--big {
    max-height: 2.125em;
}

img.session__sponsored-img .session__sponsored-img--small {
    max-height: 1.375em;
}

img.session__sponsored-img .session__sponsored-img--smaller {
    max-height: 1em;
}
</style>
